import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import { get_token , get_user_details} from "@/router";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { open_preview as open_file_preview } from "@/utils/file_preview";
import { append_active_organization_id } from "@/utils/organization_profile";


export default {
components: {
    HomeNavBar,
    Multiselect
},
data() {
    return ({
    user_details: {},
    recent_uploaded: [],
    preview_url: null,
    preview_type: null,
    loading_recent: false,
    loading_preview:false
    })
},
mounted() {
    this.user_details = get_user_details();
    this.fetch_library_resources()
},
computed: {
  filteredDocuments() {
    const allowed = ['pdf','doc','docx','xls','xlsx','ppt','pptx','txt','csv'];

    return this.recent_uploaded.filter(d => {
      const name = d.file.name.toLowerCase();
      return allowed.some(ext => name.includes(ext));
    });
  }
},
methods: {
 getToken() {
    return get_token();
    },
     formatFileSize(bytes) {
    if (!bytes) return '';
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + Reflect.get(sizes, i);
  },
get_file_class(filename) {
  if (!filename) return "";

  const ext = filename.split('.').pop().toLowerCase();

  const map = new Map([
    ["pdf", "pdf"],
    ["doc", "doc"],
    ["docx", "doc"],
    ["xls", "xls"],
    ["xlsx", "xls"],
    ["ppt", "ppt"],
    ["pptx", "ppt"],
    ["txt", "txt"],
    ["png", "img"],
    ["jpg", "img"],
    ["jpeg", "img"]
  ]);

  return map.has(ext) ? map.get(ext) : "file";
},

get_file_label(filename) {
  if (!filename) return "File";

  const ext = filename.split('.').pop().toLowerCase();

  const map = new Map([
    ["pdf", "PDF"],
    ["doc", "DOCX"],
    ["docx", "DOCX"],
    ["xls", "Excel"],
    ["xlsx", "Excel"],
    ["ppt", "PPT"],
    ["pptx", "PPT"],
    ["txt", "TXT"],
    ["png", "JPEG"],
    ["jpg", "JPEG"],
    ["jpeg", "JPEG"]
  ]);

  return map.has(ext) ? map.get(ext) : "File";
},

  downloadFile(file) {
    const link = document.createElement("a");
    link.href = file.url;
    link.download = file.name || "file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  fetch_library_resources() {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_library_documents/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ user_id: this.user_details?.user_id }),
        success: (response) => {
          if (response.status === "success") {
            this.library_resources = response.data;
          }
        },
        complete: () => {
          this.fetch_recent_uploaded();

    }
      });
    },
fetch_recent_uploaded() {
  this.loading_recent = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_recent_uploaded/`,
    method: 'POST',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(append_active_organization_id({})),
    success: (response) => {
      if (response.status === "success") {
        this.recent_uploaded = response.data.map(file_obj => {
          const isSaved = this.library_resources.some(
            doc => doc.report_file.file.id === file_obj.file.id
          );
          return { ...file_obj, is_saved: isSaved };
        });

      }
    },
    complete: () => {
      this.loading_recent = false;
    }
  });
},

    toggleLibrarySave(file_obj) {
  if (file_obj.is_saved) {
    // unsave
    this.delete_document(file_obj.file.id);
  } else {
    // save
    this.saveToLibrary(file_obj.file.id);
  }

  // Optimistic UI update
  file_obj.is_saved = !file_obj.is_saved;
},
saveToLibrary(file_id) {


  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_library_document/`,
    data: JSON.stringify({ report_file_id: file_id, user_id: this.user_details?.user_id }),
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    success: (response) => {
      if (response.status === "success") {

        // ✅ Update recent_uploaded state
        this.recent_uploaded.forEach(doc => {
          if (doc.file.id === file_id) {
            doc.is_saved = true;
          }
        });
      }
    },
  });
},

  open_preview(document) {
    open_file_preview(this, document);
  },

 on_content_loaded() {
    this.loading_preview = false;
  },

    delete_document(file_id) {
 const libraryDoc = this.library_resources.find(doc => doc.report_file.file.id === file_id);

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_library_document/`,
    method: 'DELETE',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ library_document_id: libraryDoc.id }),
    success: (response) => {
      if (response.status === "success") {
        // Remove from library resources
        const removedDoc = this.library_resources.find(doc => doc.id === libraryDoc);
        if (removedDoc) {
          const file_id = removedDoc.report_file?.file?.id;
          this.library_resources = this.library_resources.filter(doc => doc.id !== libraryDoc);

          // Update recent_uploaded state
          this.recent_uploaded.forEach(doc => {
            if (doc.file.id === file_id) {
              doc.is_saved = false;
            }
          });
        }
      }
    },
  });
}

}
}
